import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IForgotPasscodeResentOtpRequest, IForgotPasscodeResentOtpResponse } from '../models/forgot-passcode-resend-otp.model';

export const loadForgotPasscodeResendOtp = createAction(
  '[ForgotPasscodeResendOtp] Load ForgotPasscodeResendOtp',
  props<{ request: IForgotPasscodeResentOtpRequest }>()
);

export const loadForgotPasscodeResendOtpSuccess = createAction(
  '[ForgotPasscodeResendOtp] Load ForgotPasscodeResendOtp Success',
  props<{ response: IForgotPasscodeResentOtpResponse }>()
);

export const loadForgotPasscodeResendOtpFailure = createAction(
  '[ForgotPasscodeResendOtp] Load ForgotPasscodeResendOtp Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearForgotPasscodeResendOtp = createAction('[ForgotPasscodeResendOtp] Clear ForgotPasscodeResendOtp');
